import Swal from 'sweetalert2'

// Map a semantic variant to the design-system button class for the confirm
// action. Pass `variant: 'danger'` for destructive confirmations.
const CONFIRM_BTN = {
  primary: 'btn btn-primary',
  danger: 'btn btn-danger',
  accent: 'btn btn-accent'
}

// Design-system-themed confirm dialog. `buttonsStyling: false` drops
// SweetAlert's inline button styles so our `.btn` classes apply — keeping
// confirm dialogs consistent with the rest of the app (see DESIGN_SYSTEM.md).
// The popup itself is themed in application.scss (.swal2-popup).
// eslint-disable-next-line import/prefer-default-export
export const confirmAlert = ({ variant = 'primary', ...opts } = {}) => Swal.fire({
  title: 'Are you sure?',
  text: 'Once deleted, you will not be able to recover this!',
  icon: 'warning',
  showCancelButton: true,
  reverseButtons: true,
  buttonsStyling: false,
  customClass: {
    confirmButton: CONFIRM_BTN[variant] || CONFIRM_BTN.primary,
    cancelButton: 'btn btn-secondary'
  },
  confirmButtonText: 'Yes',
  ...opts
}).then((result) => result.isConfirmed)
